import {
    Model
} from '@/lib/BaseModel';

var NotificationPreferencesSchema = {

    agreeEmailNotify: {
        label: 'Agree to Receive Email Notifications',
        validation: {
            type: 'Boolean'
        }
    }

}

var NotificationPreferences = Model.make('NotificationPreferences', NotificationPreferencesSchema);

export {
    NotificationPreferences
};